import * as Immutable from 'immutable';
import merge from 'lodash/merge';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/user-list-action-types';

import type {List} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type UserListStore = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cachedUsers: List<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    users: List<any>;
    matchingUsersCount: number;
};

const initialState = (): Pick<UserListStore, 'cachedUsers'> => {
    return {
        cachedUsers: Immutable.List(),
    };
};

const baseState = (): Omit<UserListStore, 'cachedUsers'> => {
    return {
        users: Immutable.List(),
        matchingUsersCount: 0,
    };
};

const actionsMap: ActionsMap<UserListStore> = {
    [actionTypes.CACHE_BULK_UPDATE_USERS]: (state, action) => {
        return {
            cachedUsers: action.data,
        };
    },

    [actionTypes.DISPOSE]: () => {
        return baseState();
    },

    [actionTypes.REMOVE_USER_FROM_CACHED_USERS]: (state, action) => {
        return {
            cachedUsers: state.cachedUsers.filter((user) => {
                return user.get('userId') !== action.data;
            }),
        };
    },
};

export default createReducer<UserListStore>(merge(initialState(), baseState()), actionsMap);
